import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useTranslation } from '../hooks/useTranslation';
import ImpressumPageRU from './ImpressumPageRU';

export default function ImpressumPage() {
  const { isRussian, currentLanguage } = useTranslation();
  
  // Отладочная информация
  console.log('ImpressumPage - currentLanguage:', currentLanguage, 'isRussian:', isRussian);
  
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  // Показываем русскую версию если язык русский
  if (isRussian) {
    return <ImpressumPageRU />;
  }

  return (
    <div className="min-h-screen bg-white text-dark-900">
      <Header />
      <main className="pt-16 sm:pt-20">
        <motion.section
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="py-8 sm:py-16 lg:py-20"
        >
          <div className="max-w-4xl mx-auto px-3 sm:px-4 lg:px-8">
            <motion.div variants={item} className="text-center mb-8 sm:mb-12">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 text-dark-900">
                Impressum
              </h1>
              <p className="text-sm sm:text-base text-gray-600">
                Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)
              </p>
            </motion.div>

            <motion.div variants={item} className="prose prose-sm sm:prose-lg max-w-none">
              {/* Anbieterinformationen */}
              <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">
                  Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
                </h2>
                <div className="text-sm sm:text-base text-gray-700">
                  <p className="font-semibold mb-2">Alfira Herrmann</p>
                  <p>Hochburger Str. 32</p>
                  <p>79312 Emmendingen</p>
                </div>
              </div>

              {/* Kontakt */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Kontakt</h2>
                <div className="text-sm sm:text-base text-gray-700 space-y-1">
                  <p><strong>Telefon:</strong> +49 (0) 07641 95 37 645</p>
                  <p><strong>E-Mail:</strong> alphavita(@)gmx.de</p>
                </div>
              </div>

              {/* Berufsbezeichnung */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Berufsbezeichnung</h2>
                <div className="text-sm sm:text-base text-gray-700 space-y-3">
                  <p>
                    <strong>Hypnocoach (DHV)</strong> - verliehen in Deutschland, Mitglied von Deutsche Hypnose Verband. 
                    Mitgliedsnummer: DHV-01643
                  </p>
                  <p>
                    <strong>Dipl.Systemischer Business & Management Coach (CAS/ECA)</strong> - verliehen in Schweiz Coach Akademie Schweiz -CAS
                  </p>
                  <p>
                    <strong>Dipl. Lehrerin für Vorschulpädagogik und -psychologie (A4+)</strong>
                  </p>
                  <p>
                    <strong>Erzieherin</strong> - verliehen in Kasachstan an der Universität E.A. Buketova in Karaganda(H+), 
                    anerkannt als Erzieherin in Deutschland von Ministerium für Wissenschaft, Forschung und Kunst Baden-Württemberg
                  </p>
                </div>
              </div>

              {/* Aufsichtsbehörde */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Aufsichtsbehörde</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Sie können sich jederzeit mit einer Beschwerde an die für Sie zuständige Aufsichtsbehörde wenden. 
                  Ihre zuständige Aufsichtsbehörde richtet sich nach dem Bundesland Ihres Wohnsitzes, Ihrer Arbeit oder der mutmaßlichen Verletzung. 
                  Eine Liste der Aufsichtsbehörden (für den nichtöffentlichen Bereich) mit Anschrift finden Sie unter:{' '}
                  <a 
                    href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" 
                    className="text-rose-600 hover:text-rose-700 underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.bfdi.bund.de
                  </a>
                </p>
              </div>

              {/* Quellenangaben */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">
                  Quellenangaben für die verwendeten Bilder und Grafiken
                </h2>
                <div className="text-sm sm:text-base text-gray-700 space-y-3">
                  <p>
                    Einige Bilder und/oder Fotos auf dieser Seite sind das urheberrechtlich geschützte Eigentum von 123RF Limited und Freepik 
                    oder autorisierten Lieferanten, die gemäß der Lizenzbedingungen genutzt werden. Diese Bilder und/oder Fotos dürfen nicht 
                    ohne Erlaubnis von 123RF Limited oder Freepik kopiert oder heruntergeladen werden.
                  </p>
                  <div className="space-y-2">
                    <p>
                      <a 
                        href="https://www.123rf.com" 
                        className="text-rose-600 hover:text-rose-700 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Link 123RF Stock Photos
                      </a>
                    </p>
                    <p>
                      <a 
                        href="https://www.freepik.com" 
                        className="text-rose-600 hover:text-rose-700 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Link Freepik
                      </a>
                    </p>
                  </div>
                  <p>
                    Bilder von mir von fotostudio Gräber in Emmendingen{' '}
                    <a 
                      href="https://www.foto-graeber.de" 
                      className="text-rose-600 hover:text-rose-700 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.foto-graeber.de
                    </a>{' '}
                    und Meerim Kaufmann{' '}
                    <a 
                      href="https://www.maphotos.de" 
                      className="text-rose-600 hover:text-rose-700 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.maphotos.de
                    </a>{' '}
                    geschütztes Eigentum von Alphavita Alfira Herrmann
                  </p>
                  <p className="text-xs sm:text-sm text-gray-500">
                    Quelle: Erstellt mit dem Impressum-Generator der Kanzlei Siebert
                  </p>
                </div>
              </div>

              {/* Haftung für Inhalte */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Haftung für Inhalte</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. 
                  Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen 
                  zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
              </div>

              {/* Haftung für Links */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Haftung für Links</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                  Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten 
                  ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
              </div>

              {/* Urheberrecht */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Urheberrecht</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. 
                  Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                  bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind 
                  nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber 
                  erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. 
                  Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. 
                  Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                </p>
              </div>

              {/* Abmahnung */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Abmahnung</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  KEINE ABMAHNUNG ohne vorherigen schriftlichen Kontakt. Sollten irgendwelche Inhalte oder Informationen auf dieser Webseite 
                  oder auf Teilen dieses Webangebotes die Rechte Dritter verletzen oder in anderer Form wettbewerbsrechtliche Probleme verursachen, 
                  bitten wir unter Berufung auf §8 Abs. 4 UWG um eine schnelle, angemessene Nachricht ohne Kostennote. Die beanstandeten Informationen 
                  oder Inhalte werden dann in angemessener Frist entfernt beziehungsweise den rechtlichen Vorgaben entsprechend abgeändert, 
                  ohne dass die Einschaltung eines Rechtsbeistandes notwendig ist. Die Einschaltung eines Rechtsbeistandes zur kostenpflichtigen 
                  Abmahnung des Dienstanbieters entspricht nicht dem wirklichen oder mutmaßlichen Willen des Abmahnenden und ist damit ein Verstoß 
                  gegen §13 Abs. 15 UWG wegen der Verfolgung sachfremder Ziele als beherrschenden Motivs zur Verfahrenseinleitung, besonders einer 
                  Kostenerzielung als eigentlichem Grund. Sie entspricht außerdem einem Verstoß gegen die geltende Schadensminderungspflicht.
                </p>
              </div>
            </motion.div>
          </div>
        </motion.section>
      </main>
      <Footer />
    </div>
  );
}
